import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { SETTINGS_INJECTION_TOKENS } from '@tourfold/shared-kernels/settings-registry';
import { WebhooksSettings } from './settings-webhooks.component';
import { ResourceAccessGuard } from '@tourfold/shared-kernels/resource-access';

export function provideSettingsElementWebhooks(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: SETTINGS_INJECTION_TOKENS,
      useValue: {
        path: 'webhooks',
        name: 'Webhooks',
        icon: 'pi pi-link',
        component: WebhooksSettings,
        order: 2,
        translateName: 'SETTINGS_WEBHOOKS.TITLE',
        resource_key: 'webhooks',
        required_action: 'read',
        planLockedBehavior: 'upsell',
        entitlementFeatureKey: 'webhooks',
        canActivate: [ResourceAccessGuard],
        category: {
          id: 'integrations',
          name: 'Integrations',
          order: 2,
          translateName: 'SETTINGS.CATEGORIES.INTEGRATIONS',
        },
      },
      multi: true,
    },
  ]);
}
